/**
 * 上传文件（图片/音频等）：与 auth 等接口一致，使用 apiClient，请求 /web/v1/uploadImage（由 devServer proxy 转发）
 */
import apiClient from './config'

var UPLOAD_PATH = '/uploadImage?uname=dengwei_686'

/**
 * 上传文件，返回文件 URL（接口返回 imageUrl 字段，图片与音频共用）
 * @param {File} file - 文件（图片或音频等）
 * @returns {Promise<string>} 返回 fileUrl
 */
export function uploadFile(file) {
  if (!file || !(file instanceof File)) {
    return Promise.reject(new Error('请选择文件'))
  }
  var formData = new FormData()
  formData.append('file', file)
  console.log('[Upload Request] POST', UPLOAD_PATH, { file: file.name, size: file.size, type: file.type })
  return apiClient.post(UPLOAD_PATH, formData, {
    // 图片/文件上传：超时从 60s 提升到 300s
    timeout: 300000,
    headers: { 'Content-Type': undefined }
  }).then(function (data) {
    console.log('[Upload Response]', data != null ? JSON.stringify(data, null, 2) : data)
    if (data && data.code === 200 && data.imageUrl) {
      return data.imageUrl
    }
    return Promise.reject(new Error((data && data.message) || '上传失败'))
  }).catch(function (err) {
    var msg = (err && err.message) || '上传失败，请重试'
    return Promise.reject(new Error(msg))
  })
}
